import { Checkbox, TableCell, TableHead, TableRow } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';

import { useSxStyles } from './useStyles';

type Props = {
  secondCellName: string;
  thirdCellName: string;
  allSelected: boolean;
  onSelectAllChange: (value: boolean) => void;
  tableMode: boolean;
};

export const TableHeader: FC<Props> = (props: Props) => {
  const {
    secondCellName,
    thirdCellName,
    onSelectAllChange,
    allSelected,
    tableMode,
  } = props;
  const sxStyles = useSxStyles();

  const { t } = useTranslation();

  const selectAllLabel = allSelected ? t('unselectAll') : t('selectAll');

  return (
    <TableHead>
      <TableRow sx={sxStyles.headerRow}>
        <TableCell
          sx={{ ...sxStyles.firstCell, ...sxStyles.headerRowCell }}
          colSpan={2}
        >
          <Checkbox
            color={'primary'}
            onChange={() => {
              onSelectAllChange(!allSelected);
            }}
            checked={allSelected}
            title={selectAllLabel}
          />
          {selectAllLabel}
        </TableCell>
        {tableMode && (
          <>
            <TableCell
              sx={{ ...sxStyles.secondCell, ...sxStyles.headerRowCell }}
            >
              {secondCellName}
            </TableCell>
            <TableCell
              sx={{ ...sxStyles.thirdCell, ...sxStyles.headerRowCell }}
            >
              <TooltippedTruncatedText>{thirdCellName}</TooltippedTruncatedText>
            </TableCell>
          </>
        )}
      </TableRow>
    </TableHead>
  );
};
